import React, { useContext, useEffect } from "react";
import UserProgressContext from "../../userProgressContext";
import { useNavigate } from "react-router-dom";
import { saveUserProgress } from "../../services/saveUserProgress";
import BackgroundSoundToggle from "../BackgroundSound/backGroundSoundToggle";
import ProgressMap from '../UI/ProgressMap';

const GameResumePrompt = () => {
  const {
    setIsStartOver,
    progress,
    name,
    emailId,
    setProgress,
    setLocalProgress,
    setIsLevelEnd,
    setTotalScore,
    setCurrentTool,
    setRedeemedScores,
    setFinishedTasks,
    setDifficulty,
  } = useContext(UserProgressContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (!name || name.length === 0) navigate("/page-not-found");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUserChoice = () => {
    navigate(`/level/${progress}`);
  };
  const handleStartOverClick = () => {
    setIsStartOver(true);
    setProgress(0);
    setLocalProgress(null);
    setIsLevelEnd(false);
    setTotalScore(0);
    setCurrentTool(null);
    setRedeemedScores(new Set());
    setFinishedTasks(new Set());
    setDifficulty(null);
    saveUserProgress({
      name: name,
      emailId: emailId,
      progress: 0,
      totalScore: 0,
      redeemedScores: [],
      finishedTasks: [],
    });
    navigate("/");
  };
  return (
    <div className="bg-cyber-bg/75 w-full min-h-screen flex flex-col gap-12 items-center justify-center z-50 text-cyber-text">
      <h1 className="text-xl md:text-4xl font-bold text-center tracking-widest uppercase text-cyber-accent">
        Welcome Back, {name}
      </h1>
      <div className="w-full max-w-xl px-4">
        <ProgressMap
          characterNode={progress}
          fromNode={parseInt(progress) > 1 ? 1 : null}
        />
      </div>
      <div className="flex flex-col gap-4 items-center">
        <button
          className={`w-full hover:cursor-pointer bg-cyber-panel hover:bg-cyber-muted border border-cyber-accent text-cyber-accent transition-all ease-in delay-100 py-2 px-8 rounded tracking-widest uppercase text-sm md:text-base`}
          onClick={handleUserChoice}
        >
          Resume Game
        </button>
        <button
          className={`w-full hover:cursor-pointer bg-cyber-panel hover:bg-cyber-muted border border-cyber-accent text-cyber-accent transition-all ease-in delay-100 py-2 px-8 rounded tracking-widest uppercase text-sm md:text-base`}
          onClick={handleStartOverClick}
        >
          Start Over
        </button>
      </div>
      <div className="absolute top-2 md:top-4 right-4">
        <BackgroundSoundToggle />
      </div>
    </div>
  );
};
export default GameResumePrompt;
